/* eslint-disable no-console */
import { register } from "register-service-worker"; 
import Swal from 'sweetalert2';
if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "development") {
  register(`/service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
      const searchInput = document.getElementById('gsc-i-id1');
      const searchInputq = document.getElementById('q');
      document.getElementById("gsc-iw-id1").style.display = 'none';
      document.querySelector("td .gsc-search-button-v2").style.display = 'none';
      (searchInput  && searchInputq) ? searchInputq.value = searchInput.value : searchInputq.value = '';
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh......");
      checkUpdates();
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}

function checkUpdates(){
  var _this= this;
          Swal.fire({
             title: 'Alert!',
             text: 'New content available, Kindly refresh the page.',
             position: 'bottom-end',
             width: 400,
             height: 200,
             padding: '1em',
             backdrop:false,
             allowOutsideClick: false,
             confirmButtonColor: '#1c3e7f',
             confirmButtonText: 'Refresh'
         }).then((result)=>{
             if(result.value){
                 window.location.reload(true);
                 console.log('page loaded!')
             }
         });  
      }